import styled from '@emotion/styled';

export const Form = styled.form`
  width: 100%;
  height: 100%;
`;
